import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  ActiveErrorData,
  ActiveErrorsStore,
  GatewayStatus,
  InstallationDetailsStore,
} from '@store';
import { takeUntil } from 'rxjs/operators';
import { CustomTranslationsService } from 'src/app/operational-data-common/translations';
import { TooltipListPipe } from '../../pipes/tooltip-list/tooltip-list.pipe';
import { PillComponent } from '../pill/pill.component';
import { PillType } from '../pill/pill.model';

@Component({
  selector: 'app-aggregated-status-pill',
  templateUrl: './aggregated-status-pill.component.html',
  styleUrls: ['./aggregated-status-pill.component.scss'],
  standalone: true,
  imports: [CommonModule, MatTooltipModule, PillComponent, TooltipListPipe, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AggregatedStatusPillComponent implements OnInit, OnDestroy {
  @Input() gatewaySerial: string;

  gatewayStatus$: Observable<GatewayStatus>;
  getActiveGatewayErrors$: Observable<ActiveErrorData[]>;
  isLockedSystemError$: Observable<boolean>;
  maintenanceNotificationTooltip: string[] = [];

  readonly pillType = PillType;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public activeErrorsStore: ActiveErrorsStore,
    private installationDetailsStore: InstallationDetailsStore,
    protected customTranslationsService: CustomTranslationsService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.gatewayStatus$ = this.installationDetailsStore.getGatewayStatus(this.gatewaySerial);
    this.getActiveGatewayErrors$ = this.activeErrorsStore.getActiveGatewayErrors(
      this.gatewaySerial
    );
    this.isLockedSystemError$ = this.activeErrorsStore.isLockedSystemError(this.gatewaySerial);

    this.activeErrorsStore
      .getMaintenanceNotificationsDistinctByType(this.gatewaySerial)
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((notifications: ActiveErrorData[]) => {
        this.maintenanceNotificationTooltip = notifications.map((notification: ActiveErrorData) => {
          return this.translateService.instant(
            this.customTranslationsService.MAINTENANCE_NOTIFICATIONS[notification.type]
          );
        });
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
